<template>
    <console-content max-width="1024">
        <v-row class="mt-4 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">
                <span v-if="$route.params._giftcard">배송상품 상세</span>
                <span v-else>배송상품 등록</span>
            </v-col>
            <v-spacer />
        </v-row>

        <v-row class="mx-n2 my-2">
            <v-col cols="12" md="3">
                <v-card outlined v-bind="{ loading }">
                    <v-card-subtitle>
                        <v-layout wrap align-center>
                            <span>상품 썸네일</span>
                            <v-spacer />
                            <v-btn icon text hide-details class="mb-1 mt-0 pt-0" @click="removeThumb">
                                <v-icon color="red">mdi-minus</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-card-subtitle>
                    <v-divider />
                    <v-card-text>
                        <image-input v-model="product.thumb" :aspect-ratio="1 / 1" flat />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="9">
                <v-card outlined v-bind="{ loading }">
                    <v-card-subtitle>상품 상세이미지</v-card-subtitle>
                    <v-divider />
                    <v-card-text>
                        <images-input v-model="product.images" :md="2" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="8">
                <v-card outlined v-bind="{ loading }">
                    <v-card-subtitle>상품 정보</v-card-subtitle>
                    <v-divider />
                    <v-card-text>
                        <v-row no-gutters>
                            <v-col cols="12" class="pa-2">
                                <category-delivery-select v-model="product._category" :categories="categories" v-bind="{ ...attrs_input }" />
                            </v-col>
                            <v-col cols="3" class="pa-2">
                                <v-text-field v-model="product.no" label="진열 순서" v-bind="{ ...attrs_input }" />
                            </v-col>
                            <v-col v-if="isCreated" cols="4" class="pa-2">
                                <v-text-field v-model="product.code" label="상품 코드" v-bind="{ ...attrs_input }" />
                            </v-col>
                            <v-col cols="5" class="pa-2">
                                <v-text-field v-model="product.stock" type="number" label="재고" v-bind="{ ...attrs_input }" />
                            </v-col>
                            <v-col cols="12" class="pa-2">
                                <v-text-field v-model="product.name" label="상품명" v-bind="{ ...attrs_input }" />
                            </v-col>
                            <v-col cols="12" lg="3" class="pa-2">
                                <v-text-field v-model="product.supplyPrice" type="number" label="공급가" v-bind="{ ...attrs_input }" />
                            </v-col>
                            <v-col cols="12" lg="3" class="pa-2">
                                <v-text-field v-model="product.costPrice" type="number" label="소비자가" v-bind="{ ...attrs_input }" />
                            </v-col>
                            <v-col cols="12" lg="3" class="pa-2">
                                <v-text-field v-model="product.discountAmount" type="number" label="할인가" class="amount-field text-align-right-field" v-bind="{ ...attrs_input }">
                                    <template #append>
                                        <v-select
                                            v-model="product.discountUnit"
                                            :items="[
                                                { text: '원', value: 'won' },
                                                { text: '%', value: 'percent' },
                                            ]"
                                            dense
                                            v-bind="{ ...attrs_input__verticalTable }"
                                        />
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="3" class="pa-2">
                                <v-text-field v-model="salePrice" type="number" label="판매가" readonly v-bind="{ ...attrs_input }" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text>
                        <v-divider></v-divider>
                        <v-card-subtitle>상품 정보</v-card-subtitle>
                        <v-divider></v-divider>
                        <product-info v-model="product.info" />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card outlined v-bind="{ loading }">
                    <v-card-subtitle>상품 상태</v-card-subtitle>
                    <v-divider />
                    <v-card-text>
                        <v-row no-gutters>
                            <v-col cols="6" class="pa-2">
                                <v-switch v-model="product.soldout" label="품절" v-bind="{ ...attrs_switch }" />
                            </v-col>
                            <v-col cols="6" class="pa-2">
                                <v-switch v-model="product.onSale" label="판매여부" v-bind="{ ...attrs_switch }" />
                            </v-col>
                            <v-col cols="6" class="pa-2">
                                <v-switch v-model="product.onDisplay" label="전시여부" v-bind="{ ...attrs_switch }" />
                            </v-col>
                            <v-col cols="6" class="pa-2">
                                <v-switch v-model="product.isTaxFree" label="면세" v-bind="{ ...attrs_switch }" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card class="mt-4" outlined v-bind="{ loading }">
                    <v-card-subtitle>상품 이벤트</v-card-subtitle>
                    <v-divider />
                    <v-card-text>
                        <v-row no-gutters>
                            <v-col cols="6" class="pa-2">
                                <v-switch v-model="product.isBest" label="베스트" v-bind="{ ...attrs_switch }" />
                            </v-col>
                            <v-col cols="6" class="pa-2">
                                <v-switch v-model="product.isRecommend" label="추천 상품" v-bind="{ ...attrs_switch }" />
                            </v-col>
                            <v-col cols="6" class="pa-2">
                                <v-switch v-model="product.isNewly" label="신상품" v-bind="{ ...attrs_switch }" />
                            </v-col>
                            <v-col cols="6" class="pa-2">
                                <v-switch v-model="product.isPopular" label="인기 상품" v-bind="{ ...attrs_switch }" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-card class="mt-4" outlined v-bind="{ loading }">
                    <v-card-subtitle>
                        <v-layout wrap align-center>
                            <span>옵션상품</span>
                            <v-spacer />
                            <v-switch v-model="optionalEnabled" hide-details class="mb-1 mt-0 pt-0" />
                        </v-layout>
                    </v-card-subtitle>
                    <v-divider />
                    <v-expand-transition>
                        <product-optional v-show="optionalEnabled" v-model="product.optionalProducts" :salePrice="salePrice" />
                    </v-expand-transition>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-card class="mt-4" outlined v-bind="{ loading }">
                    <v-card-subtitle>상세 내용</v-card-subtitle>
                    <v-divider />
                    <v-card-text><naver-smarteditor v-model="product.content" /></v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="my-6">
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn v-bind="{ loading }" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer />
        </v-row>
    </console-content>
</template>

<script>
import api from "@/api";
import { mdiMicrosoftExcel } from "@mdi/js";
import { initDshopProdcut } from "@/assets/inits/common.inits";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import ImageInput from "@/components/console/image-input.vue";
import ImagesInput from "@/components/console/images-input.vue";
import ProductInfo from "@/components/console/shop/delivery/products/product-info.vue";
import ProductOptional from "@/components/console/shop/delivery/products/product-optional.vue";
import CategoryDeliverySelect from "@/components/console/shop/delivery/categories/category-delivery-select.vue";

export default {
    components: {
        ConsoleContent,
        NaverSmarteditor,
        ImageInput,
        ImagesInput,
        ProductInfo,
        ProductOptional,
        CategoryDeliverySelect,
    },
    data() {
        return {
            attrs_input: {
                dense: true,
                outlined: true,
                hideDetails: "auto",
                persistentPlaceholder: true,
            },
            attrs_switch: {
                inset: true,
                hideDetails: "auto",
                class: "pa-0 ma-0 d-inline-block mr-n2",
            },
            attrs_input__verticalTable: {
                flat: true,
                solo: true,
                class: "rounded-0",
                hideDetails: true,
                "persistent-placeholder": true,
            },

            mdiMicrosoftExcel,
            showSearch: true,
            loading: false,

            categories: [],
            product: initDshopProdcut(),
            optionalEnabled: false,
            categoryId: null,
        };
    },
    computed: {
        _product() {
            return this.$route.params._product;
        },
        isCreated() {
            return !!this._product;
        },
        salePrice() {
            switch (this.product.discountUnit) {
                case "won":
                    return this.product.costPrice - this.product.discountAmount;
                case "percent":
                    return Math.round(this.product.costPrice * (1 - this.product.discountAmount / 100));
                default:
                    return this.product.costPrice;
            }
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.loading) return;
            this.loading = true;

            try {
                await this.searchCategories();
                await this.searchNo();
                await this.searchProduct();
            } catch (error) {
                this.handleError(error);
            } finally {
                this.loading = false;
            }
        },
        async searchCategories() {
            try {
                let { categories } = await api.console.shop.delivery.categories.gets({ params: { depth: 1 } }, { headers: { limit: 0 } });

                this.categories = categories;
            } catch (error) {
                this.handleError(error);
            }
        },
        async searchNo() {
            try {
                let { summary } = await api.console.shop.delivery.products.summary();

                this.product.no = (summary?.totalCount || 0) + 1;
            } catch (error) {
                this.handleError(error);
            }
        },
        async searchProduct() {
            try {
                if (!this.isCreated) return;
                let { product } = await api.console.shop.delivery.products.get({ _id: this._product });

                this.product = initDshopProdcut(product);
                if (this.product?.optionalProducts?.length) this.optionalEnabled = true;
            } catch (error) {
                this.handleError(error);
            }
        },
        async save() {
            try {
                if (this.loading) return;
                this.loading = true;
                if (this.validate()) {
                    this.setProducts();

                    let { thumb, images, ...form } = this.product;

                    let { product } = await api.console.shop.delivery.products[!this.isCreated ? "post" : "put"](form);

                    if (!thumb && product.thumb) product.thumb = null;
                    if (!images.length && product.images.length) product.images = [];

                    if (thumb && thumb instanceof File) {
                        let { thumb: postedThumb } = await api.console.shop.delivery.products.thumb.post(product._id, thumb);
                        product.thumb = postedThumb;
                    }

                    if (images.length) {
                        for (let index in images) {
                            if (images[index] instanceof File) {
                                let { images: postedImages } = await api.console.shop.delivery.products.images.post(product._id, index, this.product.images[index]);

                                product.images = postedImages;
                            } else {
                                product.images = images;
                            }
                        }
                    }

                    if ((this.product?.optionalProducts || []).length) {
                        for (const optionalProduct of this.product.optionalProducts) {
                            if (!this.optionalEnabled || optionalProduct?.isDeleted) {
                                await api.console.shop.delivery.products.delete(optionalProduct);
                            } else {
                                optionalProduct?._id ? await api.console.shop.delivery.products.put({ ...product, _mainProduct: product._id, ...optionalProduct, _category: product._category, isTaxFree: product.isTaxFree }) : await api.console.shop.delivery.products.post({ ...product, _id: null, _mainProduct: product._id, ...optionalProduct });
                            }
                        }
                    }

                    await api.console.shop.delivery.products.put({ _id: product._id, _mainProduct: product._id, thumb: product.thumb, images: product.images });

                    alert("저장되었습니다");
                    this.$router.go(-1);
                }
            } catch (error) {
                console.error(error);
                alert(error?.message);
            } finally {
                this.loading = false;
            }
        },
        removeThumb() {
            if (confirm("썸네일을 삭제하시겠습니까?")) {
                this.product.thumb = null;
            }
        },
        setProducts() {
            this.product.salePrice = this.salePrice;
            if (this.optionalEnabled) this.product.stock = (this.product?.optionalProducts || []).reduce((acc, cur) => (acc += +cur?.stock || 0), 0);
            this.product.soldout = this.product.stock <= 0 ? true : false;
        },
        handleError(error) {
            console.error(error);
            alert(error?.message);
        },
        validate() {
            try {
                const { name, costPrice, _category } = this.product;

                if (!_category) throw new Error("카테고리를 선택해주세요.");
                if (!name) throw new Error("상품명을 입력해주세요.");
                if (!costPrice) throw new Error("소비자가를 입력해주세요.");
                return true;
            } catch (error) {
                alert(error.message);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .text-align-right-field {
    & > .v-input__control > .v-input__slot > .v-text-field__slot > input {
        text-align: right !important;
    }
}

::v-deep .amount-field {
    & > .v-input__control > .v-input__slot {
        padding-right: 0 !important;
    }
    & > .v-input__control > .v-input__slot > .v-input__append-inner {
        margin: 1px 0 0;
    }
    & > .v-input__control > .v-input__slot > .v-input__append-inner > .v-text-field--solo {
        width: 58px !important;

        .v-input__slot {
            padding-right: 4px;
        }
        .v-select__selections {
            justify-content: center;

            > .v-select__selection {
                margin-right: 0;
            }

            > input {
                display: none;
            }
        }

        .v-input__control,
        .v-input__slot {
            background-color: transparent;
        }
        .v-input__append-inner {
            margin-top: 0;
            padding-left: 0;
        }
    }
}
</style>